import { Action, createReducer, on } from '@ngrx/store';

import {
  exchangeBookAction,
  exchangeBookSuccessAction,
  fetchRappiPaymentChangeErrorAction
} from '@user-history/store/actions/user-history.actions';

export const initialState = false;

const featureReducer = createReducer(
  initialState,
  on(exchangeBookAction, () => true),
  on(
    exchangeBookSuccessAction,
    fetchRappiPaymentChangeErrorAction,
    () => initialState
  ),
);

export const isLoadingExchangeReducer = (state: boolean, action: Action): boolean => {
  return featureReducer(state, action);
};
